<section class="booking-event" data-testid="booking-event">
    <iframe [src]="iframeUrl" [title]="bookingEvent.title"></iframe>
</section>
